import type FeatureFlagsStore from './schema/FeatureFlagsStore';
import type { FeatureName } from './featureDefinitions';
import getFeatureFlagsKeyForSourceId from '../utils/getFeatureFlagsKeyForSourceId';

const flags = new Map<string, FeatureFlagsStore>();

export default function store(sourceId?: string): FeatureFlagsStore {
    const name = `${getFeatureFlagsKeyForSourceId(sourceId)}featureFlags`;
    let rv = flags.get(name);

    if (!rv) {
        const store: FeatureFlagsStore = {
            featureFlags: new Map<FeatureName, boolean>(),
        };
        flags.set(name, store);
        rv = store;
    }

    return rv;
}
